'use strict'

// import React from 'react'

// import Dyn from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';


import React from "react";

class SampleStatsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            precision: this.precisionDisplayString()
        };
    }

    componentDidMount = () => {
        var Dyn = this.props.Dyn;
        this.subscriptions = [];
        Dyn.mediatorLocalSubscribe( this.subscriptions, "sampleStats:updated", this.updateTable);
        Dyn.mediatorLocalSubscribe( this.subscriptions, "pref:newPrecision", (args) => {
            this.setState({
                precision: this.precisionDisplayString()
            })
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:randomSamplesUpdated", (args) => {
            // change the radio button state to view the current sample.
            if( isFinite( args.sampleIndex )) {
                this.activeSampleId = args.sampleIndex + 1;
                // TODO: update table state to match, needed if message comes from RandomSampleComponent (e.g. radio.focus(), etc)
                if( document.getElementById("sampleRow_"+this.activeSampleId) ){
                    document.getElementById("sampleRow_"+this.activeSampleId).checked = true;
                }
            }
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "records:setCasesSelected", this.handleCasesSelected);
    }

    componentWillUnmount = () => {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }

    /**
     * Update table based plot measures
     * @param args.sampleStats -- sample stats object owned by plot
     * @param args.caseSampler -- case Sampler object owned by dataSet
     */
    updateTable = ( args ) => {
        /**
         * constructor for a single table
         * @constructor
         */
        function SingleTable() {
            this.showColumnHeaders = true;
            this.columns = [ // the column cell values of the first row (a header row)
                {}, // radio button selector
                { value: Dyn.loc("Sample No.") },
                { value: Dyn.loc("Sample Name") },
                { value: Dyn.loc("n")}];
            this.rows = [];
            this.title = "";
            this.htmlTable = null;
            this.htmlTitle = "";
            this.attributeId = "";
        }

        let Dyn = this.props.Dyn,
            table,
            needAnotherTable,
            sampleStatsContainer = this.refs.sampleStatsContainer;

        // update selected sample and activeView (population, samples, or distribution)
        this.activeSampleId = args.caseSampler.getSelectedSampleIndex() + 1;
        this.activeView = args.caseSampler.selectedView;

        // construct rows and columns of tables (one table per attribute per Dyn.SampleStats.stats structure)
        this.tables = [];

        /*{   // make a table to select Distribution/Samples/Population
            table = new SingleTable();
            table.title = "View";
            table.attributeId = "";
            table.isSampleTable = false;
            table.columns = []; // no column headings
            let rows = [
                { text:Dyn.loc("Population"), id:'viewPopulation' },
                { text:Dyn.loc("Sample"), id:'viewSample' },
                { text:Dyn.loc("Distribution of Sample Statistics"), id:'viewDistribution' },
            ];
            rows.forEach( row => {
                let individual_row = [];
                individual_row.push(
                    {}, // dummy cell for radio button
                    { value: row.text, id:row.id });
                table.rows.push(individual_row);
            });
            this.tables.push( table );
        }*/
        let measureElements = args.sampleStats.measureElements;
        do {
            args.sampleStats.statTableData.forEach( (statItem, itemIndex) => {
                // if the attribute is not on the axis, but only in statTableData
                // object, isVisible() will be false
                if ( statItem.isVisible() ) {
                    table = new SingleTable();
                    table.title = statItem.attributeName;
                    table.attributeId = statItem.attributeId;
                    table.isSampleTable = true;
                    if( statItem.columnMap && statItem.columnMap.sampleNum ) { // will be null if we have a table but no samples generated (yet)
                        let sampleNumberCol = statItem.columnMap.sampleNum;
                        sampleNumberCol.caseValues.forEach( (rowNum, rowIndex) => { // for each row in table
                            let individual_row = [ {} ]; // dummy cell for radio button
                            statItem.columnIds.forEach( (colID, colIndex) => { // for each column in table
                                let statsColumn = statItem.columnMap[colID];
                                // add measure column headings; standard ones are added in SingleTable()
                                if( rowIndex===0 && statsColumn.isAMeasure() ) {
                                    table.columns.push({
                                        "value": measureElements[colID].measureName,
                                        "attributeID": statItem.attributeId
                                    });
                                }
                                // set cell values for row
                                individual_row.push({ value: statsColumn.caseStrings[rowIndex] });
                            });
                            table.rows.push( individual_row );
                        });
                    }
                    // else if ( statItem.samples ) { // will be null if we have a table but no samples generated (yet)
                    //     statItem.samples.forEach( (sample, index) => {
                    //         if ( sample.measuresArray && index == 0 ) {
                    //             sample.measuresArray.forEach( (measure) => {
                    //                 table.columns.push({
                    //                     "value": measure.name,
                    //                     "attributeID": statItem.attributeId
                    //                 });
                    //             });
                    //         }
                    //         // push the fixed row values
                    //         let individual_row = [];
                    //         //individual_row.push({}); // dummy cell for radio button
                    //         individual_row.push(
                    //             {}, // dummy cell for radio button
                    //             { value: sample.index },
                    //             { value: sample.name },
                    //             { value: sample.caseCount },
                    //         );
                    //         // push the row's statistical values
                    //         if ( sample.measuresArray ) {
                    //             sample.measuresArray.forEach( (measure) => {
                    //                 individual_row.push({
                    //                     "value": measure.value
                    //                 });
                    //             });
                    //         }
                    //         table.rows.push(individual_row)
                    //     });
                    // }
                    this.tables.push( table );
                }
            });
        } while ( needAnotherTable );

        // cleanup the previously created summary
        sampleStatsContainer.innerHTML = "";

        // (re-)construct table from plot measures
        this.tables.forEach( ( table, tableIndex ) => {
            if (table.rows.length > 0) {
                // construct HTML for title and table
                if ( table.title ) {
                    table.htmlTitle           = document.createElement( 'h3' );
                    table.htmlTitle.classList.add("tde-summary-inner-title");
                    table.htmlTitle.innerHTML = table.title;
                }
                table.htmlTable = this._constructTable( table.columns, table.rows, tableIndex, table.attributeId, table.isSampleTable );
                if( table.title ) {
                    sampleStatsContainer.appendChild( table.htmlTitle );
                }
                sampleStatsContainer.appendChild( table.htmlTable );
            }
        });
        // args.statTableData[0].samples[0].measuresArray[0].name + " of " + args.statTableData[0].attributeName + " is " + args.statTableData[0].samples[0].measuresArray[0].value
        console.log("SampleStatsComponent:updateTable() "+this.tables.length+" tables, "
            +(this.tables.length&&this.tables[0].rows.length)+ " rows.");
    }


    /**
     * Update table based on columns and rows
     */
    _constructTable = ( columns, rows, tableIndex, attributeId, isSampleTable ) => {
        "use strict";
        var Dyn = this.props.Dyn;
        var table     = document.createElement( 'table' ),
            headerRow = table.insertRow( 0 ),
            dataSet = Dyn.dataSet,
            self = this;
        columns.forEach( function ( colValue, colIndex ) {
            var htmlCell       = headerRow.insertCell( colIndex );
            if(colIndex > 0) {
                htmlCell.innerHTML = '<strong>' + colValue.value + '</strong>';
            }
            htmlCell.setAttribute("index", colIndex);
        } );


        rows.forEach( function ( rowValues, rowIndex ) {
            let row           = table.insertRow( rowIndex + 1 );
            let htmlCellIndex = 0;
            rowValues.forEach( function ( rowValue, cellIndex ) {
                if ( !rowValue.skip ) {
                    let htmlCell       = row.insertCell( htmlCellIndex++ );
                    if(cellIndex === 0){
                        let radio = document.createElement("INPUT"),
                            isChecked = (rowValues[1].value == self.activeSampleId && self.activeView==='viewSample');
                        radio.setAttribute("type", "radio");
                        radio.setAttribute("id", "sampleRow_" + tableIndex + "_" + rowValues[1].value);
                        radio.setAttribute("aria-label",  "Sample Statistics row " + rowValues[1].value);
                        //if( isSampleTable ) {
                            radio.setAttribute("name", "sample_" + attributeId);
                            radio.setAttribute("value", rowValues[1].value);
                            radio.setAttribute("tabindex", 0);
                            radio.onclick = function(e) {
                                self.viewOneSample(e.target.value);
                            };
                            radio.checked = isChecked;
                            if( isChecked ) {
                                //radio.setAttribute("checked", "checked");
                                // Mark the element as focused after it is added into the DOM
                                setTimeout(() => {
                                    radio.focus();
                                }, 100);
                            }
                        // } else {
                        //     // select Pop, Sample, Dist table
                        //     radio.setAttribute("name", rowValues[1].id );
                        //     radio.setAttribute("value", rowValues[1].id );
                        //     radio.setAttribute("tabindex", 0);
                        //     radio.onclick = function(e) {
                        //         self.selectDataset(e.target.value);
                        //     };
                        //     if(rowValues[1].id == self.activeView) {
                        //         radio.setAttribute("checked", "checked");
                        //         // Mark the element as focused after it is added into the DOM
                        //         setTimeout(() => {
                        //             radio.focus();
                        //         }, 100);
                        //     }
                        // }
                        htmlCell.appendChild(radio);
                    } else {
                        htmlCell.innerHTML = rowValue.header ? '<strong>' + rowValue.value + '</strong>' : rowValue.value;
                    }
                    // Set custom attributes row and col
                    htmlCell.setAttribute("row", rowIndex);
                    htmlCell.setAttribute("col", cellIndex);
                }
            } );
        } );

        return table;
    }

    // To publish selected sampleId
    viewOneSample = (radioID) => {
        var mediator = this.props.Dyn.mediator;
        // NOTE: pass in setID if and when we allow multiple sets, otherwise assume setID: 0
        mediator.publish( "records:viewSample", {sampleIndex: Number( radioID - 1)});
    }

    /**
     * Handle a "records:setCasesSelected" message from Dyn.DataSet
     * @param args
     */
    handleCasesSelected = ( args ) => {
        let Dyn = this.props.Dyn,
            dataSet = Dyn.dataSet,
            self = this;

        // TODO: update the table style to match selection
        //  if we are viewing a distribution in the plot,
        //  then the selected case indicates the sample number
        //  and our table row index indicates the sample number
        //  if they match, change the row style
        function setSelected( htmlCell, cell /*, args */ ) {
            let sampleIndex = htmlCell.getAttribute('row'),
                isSelected = dataSet.isCaseSelected( sampleIndex );
            if(isSelected) {
                //TODO self._appendClassName(htmlCell, self._cellSelectedClass);
            } else {
                //TODO self._removeClassName(htmlCell, self._cellSelectedClass);
            }
        }

        if( dataSet.caseSampler.isDistributionSelected() ) {
            console.log("selected sample no. ", args.ids );
            //TODO this._forEachTableCell(setSelected, args);
        }
    }

    // To publish a request to view the Distribution of Samples table/plot
    /*selectView = (radioID) => {
        var mediator = this.props.Dyn.mediator;
        console.log("selectView", radioID );
        switch( radioID ){
            case "viewDistribution":
                mediator.publish("records:viewDistribution", {});
                break;
            case "viewPopulation":
                mediator.publish("records:viewPopulation", {});
                break;
            default: // re-select last sample, similar to viewOneSample()
                mediator.publish( "records:viewSample", { sampleIndex: Number(this.activeSampleId-1)});
        }
    }
    */

    printMe = () => {
        this.setState({
            printClassName: 'tde-print-me'
        });
        setTimeout(() => {
            window.print();
            this.setState({
                printClassName: ''
            });
        }, 200);
    }

    morePrecision = () => {
        let preferences = this.props.Dyn.preferences;
        preferences.setPrecision( preferences.getPrecision() + 1 );
    }

    lessPrecision = () => {
        let preferences = this.props.Dyn.preferences;
        preferences.setPrecision( preferences.getPrecision() - 1 );
    }

    precisionDisplayString = () => {
        let p = this.props.Dyn.preferences.getPrecision();
        return p==0? "" : ("["+((p<0)?"-":"+")+Math.abs(p)+"]");
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        // NOTE: translation may be missing on first render, before Dyn.dataset constructed, later rerendering will fix this.
        return ( Dyn.dataSet ) ? Dyn.loc(str) : str;
    }

    // Render the UI
    render = () => {
        return (
            <div className="tde-summary-table">
                <div className="tde-summary-table-buttons tde-bg-color">
                    <div onClick={this.lessPrecision} className="tde-precision-minus-icon"><i className="tde-i tde-i-minus" title={this.getLoc("Less precision (more rounding)")}></i></div>
                    <div onClick={this.morePrecision} className="tde-precision-plus-icon"><i className="tde-i tde-i-add" title={this.getLoc("More precision (less rounding)")}></i></div>
                    <div className="tde-precision-value" title="extra digits added to statistic's significant figures">{ this.state.precision }</div>
                    <div onClick={this.printMe} className="tde-print-icon"><i className="tde-i tde-i-print" title="Print"></i></div>
                </div>
                <div ref="sampleStatsContainer" className={'tde-summary-container ' + (this.state.printClassName || '') }> Stats for Samples </div>
            </div>
        )
    }

}

export default SampleStatsComponent
